import type { VandalizedPosterRow } from "../api/posters";

/** Handläggningsfilter som delas av tabell- och kartvyn för vandaliserade affischer. */
export type HandlingFilter = "all" | "notReported" | "reported" | "open" | "closed";

export const HANDLING_LABELS: Record<HandlingFilter, string> = {
    all: "Alla",
    notReported: "Ej polisanmälda",
    reported: "Polisanmälda",
    open: "Ej åtgärdade",
    closed: "Åtgärdade (nedtagna/lagade)"
};

export const dateText = (value: string | null): string =>
    value ? new Date(value).toLocaleDateString("sv-SE") : "–";

/** Ett ärende är stängt när affischen antingen tagits ned eller lagats. */
export const isClosed = (row: VandalizedPosterRow): boolean =>
    row.takenDownAt !== null || row.repairedAt !== null;

export const matchesHandling = (row: VandalizedPosterRow, handling: HandlingFilter): boolean => {
    switch (handling) {
        case "notReported":
            return row.policeReportedAt === null;
        case "reported":
            return row.policeReportedAt !== null;
        case "open":
            return !isClosed(row);
        case "closed":
            return isClosed(row);
        default:
            return true;
    }
};

